import Text from "../../Components/Text"
import Button from "../../Components/Buttons/Button"
import { useEffect, useState } from "react";
import { createOrUpdateTimeTracking } from "../../Model/TimeTracking";
import Avatar from "../../Components/Avatar";

export const ClockIn = ({ obj, afterAction = null }) => {
    const [elapsed, setElapsed] = useState(null);

    useEffect(() => {
        if (!obj.startTime) {
            setElapsed(null);
            return;
        }

        const start = parseAsUTC(obj.startTime);

        const updateElapsed = () => {
            const diffMs = Date.now() - start.getTime();
            setElapsed(formatDuration(diffMs));
        };

        updateElapsed();
        const interval = setInterval(updateElapsed, 1000);

        return () => clearInterval(interval);
    }, [obj.startTime]);

    const startTimeLabel = obj.startTime
        ? formatTime(parseAsUTC(obj.startTime))
        : null;

    async function createOrUpdateEntry() {
        if (obj.startTime) {
            obj.endTime = new Date()
        } else {
            obj.startTime = new Date()
        }
        await createOrUpdateTimeTracking(obj)
        if (afterAction) {
            afterAction()
        }
    }

    return (
        <div className="w-full h-full flex flex-col gap-2">
            <div className="flex gap-3">
                <Avatar firstname={obj.user.firstName} lastname={obj.user.lastName} preview={true} />
                <div className="flex flex-col">
                    <Text type="maintitle">{obj.user.firstName}</Text>
                    <Text type="itemtext">{obj.startTime ? "Eingestempelt" : "Nicht Eingestempelt"}</Text>
                </div>
                
            </div>
            
            {elapsed && (
                <div className="w-full rounded-lg bg-gray-100 flex flex-col gap-1 text-center">
                    {startTimeLabel && (
                        <Text type="itemtext">Seit {startTimeLabel} Uhr eingestempelt</Text>
                    )}
                    <Text type="main">{elapsed}</Text>
                </div>
            )}
            <Button
                tIconName={obj.startTime ? "clock-cancel" : "clock-check"}
                text={obj.startTime ? "Ausstempeln" : "Einstempeln"}
                onClickAction={() => createOrUpdateEntry()}
                buttonColor={obj.startTime ? "bg-red-500" : "bg-green-500"}
            />
        </div>
    )
}

function formatDuration(ms) {
    if (ms < 0) ms = 0;
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const pad = (n) => String(n).padStart(2, "0");
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

function parseAsUTC(dateString) {
    if (/Z|[+-]\d{2}:\d{2}$/.test(dateString)) {
        return new Date(dateString);
    }
    return new Date(dateString + "Z");
}

function formatTime(date) {
    return date.toLocaleTimeString("de-CH", {
        hour: "2-digit",
        minute: "2-digit",
    });
}